// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"1df215fa","290":"6da45af0","716":"6c7db066"}[chunkId] + ".chunk.js";
};